import { getProperty } from 'reporting-data/v2/dataset/datasetTypes';

// SF returns the dataset in the order of the dateTimePart column
// We can not always assume that the data[0] is the compared data and data[1] is the primary data
// For example, if the dateTimePart is 'MONTH' and we are comparing Jan 2025 with Dec 2024.
// The data[0] will be Dec 2024 and data[1] will be Jan 2025
// in this case the primaryData is the data[0] and comparedData is the data[1]
// In the case BE sort this dataset accordingly, we should remove this function
export const shouldInverseDataRows = ({
  data,
  compareColumn
}) => {
  var _getProperty;
  const propertyFormat = (_getProperty = getProperty(data.primary, compareColumn)) === null || _getProperty === void 0 ? void 0 : _getProperty.format;
  const dateTimePart = propertyFormat === null || propertyFormat === void 0 ? void 0 : propertyFormat.dateTimePart;
  const firstData = data.primary.data[0][compareColumn];
  const secondData = data.primary.data[1][compareColumn];
  return dateTimePart === 'MONTH' && firstData === 1 && secondData === 12 || dateTimePart === 'QUARTER' && firstData === 1 && secondData === 4;
};